import * as React from 'react';
import { Grid, Col } from 'react-bootstrap';
import Helmet from 'react-helmet';
import Radium from 'radium';

import Workshops from './../components/workshops';

@Radium
export default class WorkshopCategoriesPage extends React.Component {
  render() {
    return (
      <Grid>
        <Helmet>
          <title>Workshopy - Stužák</title>
        </Helmet>
        <Col md={10} mdOffset={1} sm={12} style={{ padding: 0 }}>
          <Workshops />
        </Col>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/workshopcategoriespage/index.jsx